import { render, staticRenderFns } from "./CompanyClientContractLimit.vue?vue&type=template&id=3cfbc3a3&scoped=true&"
import script from "./CompanyClientContractLimit.vue?vue&type=script&lang=js&"
export * from "./CompanyClientContractLimit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyClientContractLimit.vue?vue&type=style&index=0&id=3cfbc3a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbc3a3",
  null
  
)

export default component.exports